import { render } from "./PlatformDashboard.vue?vue&type=template&id=3362eab4&scoped=true"
import script from "./PlatformDashboard.vue?vue&type=script&lang=js"
export * from "./PlatformDashboard.vue?vue&type=script&lang=js"

import "./PlatformDashboard.vue?vue&type=style&index=0&id=3362eab4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3012/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3362eab4"]])

export default __exports__